const ResetModal = function () {
  //this.editRole.hideModal()
  this.editRole.resetForm()
  this.editRole.loader.hideLoader()
  this.editRole.submitButton.setEnabled()
}

export default ResetModal
